import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import { SELECT_APPLICATION_ACTION_TYPE, headers, GET_SPONSORSHIP_LIST, getSponsershipListUrl, GET_SPONSORSHIP_DETAILS, INSERT_SPONSORSHIP_INTEREST, getSponsershipDetailsUrl, insertSponsorshipInterestUrl, insertUpdateSponsorshipMasterUrl, getSponsorshipMasterDetailsUrl, GET_SPONSORSHIP_MASTER, INSERT_UPDATE_SPONSORSHIP_MASTER, deleteSponsorshipMasterUrl, DELETE_SPONSORSHIP_MASTER } from "../../../utils/constants"



export const getSponsershipList_action = (ExhCompanyName, VisitorCompanyName, SponsorshipTypeId) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhCompanyName: ExhCompanyName != '' ? ExhCompanyName : null,
            VisitorCompanyName: VisitorCompanyName != '' ? VisitorCompanyName : null,
            SponsorshipTypeId: SponsorshipTypeId != '' ? SponsorshipTypeId : null,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(getSponsershipListUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: GET_SPONSORSHIP_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteSponsorshipMaster_action = (ExhibitionID, id) => async (dispatch) => {

    try {

        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            SponsorshipHdrID: id,
            // SponsorshipTypeID: SponsorshipTypeID,
            ExhibitionID: ExhibitionID,
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(deleteSponsorshipMasterUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: DELETE_SPONSORSHIP_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getSponsorshipMasterDetails_action = (ExhibitionID, SponsorshipHdrID, SponsorshipTypeID) => async (dispatch) => {

    try {

        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            SponsorshipHdrID: SponsorshipHdrID,
            SponsorshipTypeID: SponsorshipTypeID,
            ExhibitionID: ExhibitionID,
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(getSponsorshipMasterDetailsUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: GET_SPONSORSHIP_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getSponsershipDetails_action = (exhId) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationId: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorId: sessionStorage.getItem('currentVisitorID') != '' && sessionStorage.getItem('currentVisitorID') != null ? (sessionStorage.getItem('currentVisitorID')) : null,
            ExhibitionID: exhId != '' && exhId != null && exhId != undefined ? exhId : sessionStorage.getItem('sessionExhibitionID'),
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(getSponsershipDetailsUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: GET_SPONSORSHIP_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateSponsorshipMaster_action = (SponsorshipHdrID, ExhibitionID, SponsorshipTypeID, TotalQty, AvailableQty, AmountINR, AmountUSD, IsDeliverableAsPDF, IsDeliverableAsCommonPDF, DeliverableCommonPdfPath, IsShowToExhibitor, IsShowToVisitor, SponsorshipStatusID, IsDeliverableAsPDFFile, IsDeliverableAsPDFType, DeliverablePdfPath, SponsorshipTypeName, IsDeliverableAsCommonPDFFile, IsDeliverableAsCommonPDFType, deliverableList,) => async (dispatch) => {
    try {
        const mapData = {
            SponsorshipHdrID: SponsorshipHdrID,
            ExhibitionID: ExhibitionID,
            SponsorshipTypeID: SponsorshipTypeID,
            TotalQty: TotalQty,
            AvailableQty: AvailableQty,
            AmountINR: AmountINR != '' && AmountINR != null ? parseInt(AmountINR) : null,
            AmountUSD: AmountUSD != '' && AmountUSD != null ? parseInt(AmountUSD) : null,
            IsDeliverableAsPDF: IsDeliverableAsPDF,
            DeliverableCommonPdfPath: DeliverableCommonPdfPath,
            IsShowToExhibitor: IsShowToExhibitor,
            IsShowToVisitor: IsShowToVisitor,
            SponsorshipStatusID: SponsorshipStatusID,
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            IsDeliverableAsPDFFile: IsDeliverableAsPDFFile,
            IsDeliverableAsPDFType: IsDeliverableAsPDFType,
            DeliverablePdfPath: DeliverablePdfPath,
            SponsorshipTypeName: SponsorshipTypeName,
            IsDeliverableAsCommonPDF: IsDeliverableAsCommonPDF,
            IsDeliverableAsCommonPDFFile: IsDeliverableAsCommonPDFFile,
            IsDeliverableAsCommonPDFType: IsDeliverableAsCommonPDFType,
            deliverableList: deliverableList
        }
        console.log("Space Booking Action ----->", mapData)
        const res = await axiosPost(insertUpdateSponsorshipMasterUrl, mapData, headers)

        dispatch({
            type: INSERT_UPDATE_SPONSORSHIP_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }

}

export const insertSponsorshipInterest_action = (SponsorshipHdrID, AppliedQty, AdditionalNote, maildata) => async (dispatch) => {
    maildata.UserId = JSON.parse(sessionStorage.getItem('loginDataSS')).UserID
    maildata.ExhibitionID = sessionStorage.getItem('sessionExhibitionID')
    maildata.ExhRegistrationID = sessionStorage.getItem('ExhRegistrationIDSS')
    maildata.ExhVisitorID = (sessionStorage.getItem('currentVisitorID'))
    try {
        const mapData = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationId: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorId: sessionStorage.getItem('currentVisitorID') != '' && sessionStorage.getItem('currentVisitorID') != null ? (sessionStorage.getItem('currentVisitorID')) : '',
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            SponsorshipHdrID: SponsorshipHdrID,
            AppliedQty: AppliedQty,
            AdditionalNote: AdditionalNote,
            maildata: maildata
        }
        console.log("Space Booking Action ----->", mapData)
        const res = await axiosPost(insertSponsorshipInterestUrl, mapData, headers)

        dispatch({
            type: INSERT_SPONSORSHIP_INTEREST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }

}